/*******************************************************
 * 1) AGE VERIFICATION POPUP + CHECKOUT HOOK (V3)
 *******************************************************/
(function () {
  if (window.__AGE_CHECK_V3__) return;
  window.__AGE_CHECK_V3__ = true;

  function showAgeVerificationPopup() {
    const overlay = document.createElement("div");
    overlay.id = "ageVerificationOverlay";
    Object.assign(overlay.style, {
      position: "fixed",
      inset: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "99999",
    });

    const popup = document.createElement("div");
    Object.assign(popup.style, {
      background: "white",
      padding: "20px",
      borderRadius: "10px",
      textAlign: "center",
      width: "500px",
      maxWidth: "90%",
    });

    const message = document.createElement("p");
    message.innerText = "Lai veiktu pirkumu, jāveic vecuma pārbaude.";
    Object.assign(message.style, {
      fontSize: "22px",
      marginBottom: "20px",
      fontWeight: "bold",
    });

    const btnRow = document.createElement("div");
    Object.assign(btnRow.style, {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
    });

    const confirmButton = document.createElement("button");
    confirmButton.innerText = "Pārbaudīt vecumu";
    confirmButton.className = "m-button m-button--primary";
    confirmButton.onclick = () => {
      window.location.href =
        "https://dokubit.digiprof.lv/auth/premiumdzerieni/redirect/";
    };

    const cancelButton = document.createElement("button");
    cancelButton.innerText = "Atcelt";
    Object.assign(cancelButton.style, {
      backgroundColor: "#ccc",
      padding: "10px 20px",
      borderRadius: "5px",
      cursor: "pointer",
      border: "none",
    });
    cancelButton.onclick = () => overlay.remove();

    btnRow.appendChild(confirmButton);
    btnRow.appendChild(cancelButton);
    popup.appendChild(message);
    popup.appendChild(btnRow);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
  }

  function attachCheckoutAgeVerification() {
    const buttons = document.querySelectorAll("[name='checkout']");
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      if (btn.dataset.ageCheckAttached === "true") return;
      btn.dataset.ageCheckAttached = "true";

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        showAgeVerificationPopup();
      });
    });
  }

  window.attachCheckoutAgeVerification = attachCheckoutAgeVerification;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachCheckoutAgeVerification);
  } else {
    attachCheckoutAgeVerification();
  }
})();

/*******************************************************
 * 2) GLOBAL AJAX INTERCEPTOR (reliable cart updates)
 *******************************************************/
(function () {
  if (window.__CART_AJAX_MONITOR__) return;
  window.__CART_AJAX_MONITOR__ = true;

  (function (open) {
    XMLHttpRequest.prototype.open = function () {
      this.addEventListener("load", function () {
        try {
          const url = this.responseURL || "";
          if (
            url.includes("/cart/add") ||
            url.includes("/cart/change") ||
            url.includes("/cart/update")
          ) {
            document.dispatchEvent(new CustomEvent("cart:updated"));
          }
        } catch (err) {}
      });
      return open.apply(this, arguments);
    };
  })(XMLHttpRequest.prototype.open);
})();

/*******************************************************
 * 3) DEPOSIT SYSTEM V23-PATCH (No MutationObserver)
 *******************************************************/
(function () {
  if (window.__DEPOSIT_SYSTEM_V23_PATCH__) return;
  window.__DEPOSIT_SYSTEM_V23_PATCH__ = true;

  const DEPOSIT_TAG = "deposit";
  const DEPOSIT_HANDLE = "depozits";
  const DEPOSIT_VARIANT_ID = 55103690375502;

  let syncLock = false;
  let syncPending = false;
  let lastReason = "";
  let debounceTimer = null;

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));

  async function fetchCart() {
    try {
      const r = await fetch("/cart.js?ts=" + Date.now());
      return await r.json();
    } catch (e) {
      console.error("[Deposit] fetchCart error", e);
      return null;
    }
  }

  async function fetchProductTags(handle) {
    if (!handle) return [];
    try {
      const r = await fetch(`/products/${handle}?view=product-tags.json`);
      const text = await r.text();
      if (text.trim().startsWith("<")) return [];
      const json = JSON.parse(text);
      return Array.isArray(json.tags) ? json.tags : [];
    } catch (e) {
      console.error("[Deposit] tag fetch error", handle, e);
      return [];
    }
  }

  function updateBubbleCount(totalQty) {
    const count = String(totalQty || 0);
    document
      .querySelectorAll(".m-cart-count-bubble,.m-cart-count")
      .forEach((el) => (el.textContent = count));
    document
      .querySelectorAll("a.m-cart-icon-bubble[aria-label]")
      .forEach((a) => a.setAttribute("aria-label", count));
  }

  async function secureCartChange(updates) {
    const form = new FormData();
    Object.keys(updates).forEach((k) =>
      form.append(`updates[${k}]`, updates[k])
    );

    try {
      await fetch("/cart", {
        method: "POST",
        body: form,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
    } catch (e) {
      console.error("[Deposit] secureCartChange error", e);
    }
  }

  async function reloadCartPageSection() {
    if (!window.location.pathname.includes("/cart")) return;

    try {
      const r = await fetch("/cart?sections=cart-template", {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const sections = await r.json();
      const tplHtml = sections["cart-template"];
      if (!tplHtml) return;

      const tmp = document.createElement("div");
      tmp.innerHTML = tplHtml;

      const newCart = tmp.querySelector("#MinimogCart");
      const oldCart = document.querySelector("#MinimogCart");
      if (!newCart || !oldCart) return;

      const oldItemsContainer = oldCart.querySelector(
        "[data-minimog-cart-items]"
      );
      const newItemsContainer = newCart.querySelector(
        "[data-minimog-cart-items]"
      );
      if (oldItemsContainer && newItemsContainer) {
        oldItemsContainer.innerHTML = newItemsContainer.innerHTML;
      }

      const oldFooter = oldCart.querySelector("#MinimogCartFooter");
      const newFooter = newCart.querySelector("#MinimogCartFooter");
      if (oldFooter && newFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      }

      if (typeof window.attachCheckoutAgeVerification === "function") {
        window.attachCheckoutAgeVerification();
      }
    } catch (e) {
      console.error("[Deposit] Cart page reload error", e);
    }
  }

  async function reloadDrawer() {
    try {
      const drawer = document.querySelector("m-cart-drawer");
      if (!drawer) return;

      const wasOpen = drawer.classList.contains("m-cart-drawer--active");

      const r = await fetch("/cart?sections=cart-drawer,cart-icon-bubble", {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const s = await r.json();

      const newHTML = s["cart-drawer"];
      if (newHTML) {
        const tmp = document.createElement("div");
        tmp.innerHTML = newHTML;
        const newDrawer = tmp.querySelector("m-cart-drawer");

        if (newDrawer) {
          const oldHeader = drawer.querySelector(".m-cart-drawer__header");
          const newHeader = newDrawer.querySelector(".m-cart-drawer__header");
          if (oldHeader && newHeader) {
            oldHeader.innerHTML = newHeader.innerHTML;
          }

          const oldItems = drawer.querySelector("m-cart-drawer-items");
          const newItems = newDrawer.querySelector("m-cart-drawer-items");
          if (oldItems && newItems) {
            oldItems.innerHTML = newItems.innerHTML;
          }

          const oldFooter = drawer.querySelector(".m-cart-drawer__footer");
          const newFooter = newDrawer.querySelector(".m-cart-drawer__footer");
          if (oldFooter && newFooter) {
            oldFooter.innerHTML = newFooter.innerHTML;
          }
        }
      }

      if (wasOpen) {
        drawer.classList.add("m-cart-drawer--active");
        drawer.open?.();
      }

      if (typeof window.attachCheckoutAgeVerification === "function") {
        window.attachCheckoutAgeVerification();
      }
    } catch (e) {
      console.error("[Deposit] Drawer reload error", e);
    }
  }

  function scheduleSync(reason) {
    lastReason = reason;
    syncPending = true;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runSyncLoop, 250);
  }

  async function runSyncLoop() {
    if (syncLock) return;
    if (!syncPending) return;

    syncPending = false;
    syncLock = true;

    try {
      await syncDeposit(lastReason);
    } catch (e) {
      console.error("[Deposit] sync error", e);
    } finally {
      syncLock = false;
      if (syncPending) runSyncLoop();
    }
  }

  async function syncDeposit(reason) {
    await wait(600);

    const cart = await fetchCart();
    if (!cart || !Array.isArray(cart.items)) return;

    updateBubbleCount(cart.item_count || 0);

    let required = 0;
    let depositLine = null;

    for (const item of cart.items) {
      if (
        item.id == DEPOSIT_VARIANT_ID ||
        item.variant_id == DEPOSIT_VARIANT_ID ||
        item.handle === DEPOSIT_HANDLE
      ) {
        depositLine = item;
        continue;
      }

      const tags = await fetchProductTags(item.handle);
      if (tags.includes(DEPOSIT_TAG)) {
        required += item.quantity;
      }
    }

    const current = depositLine ? depositLine.quantity : 0;

    if (current !== required) {
      try {
        if (required === 0 && depositLine) {
          await secureCartChange({ [depositLine.key]: 0 });
        } else if (!depositLine && required > 0) {
          await secureCartChange({ [DEPOSIT_VARIANT_ID]: required });
        } else if (depositLine && required > 0) {
          await secureCartChange({ [depositLine.key]: required });
        }
      } catch (e) {
        console.error("[Deposit] update error", e);
      }
    }

    await wait(250);
    await reloadDrawer();
    await reloadCartPageSection();
  }

  function initListeners() {
    document.addEventListener("cart:refresh", () =>
      scheduleSync("cart:refresh")
    );

    document.addEventListener("cart:updated", () =>
      scheduleSync("ajax updated")
    );

    document.addEventListener("submit", (e) => {
      if (e.target.closest('form[action="/cart/add"]')) {
        scheduleSync("add form");
      }
    });

    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-add-to-cart],button[name='add']")) {
        scheduleSync("add click");
      }

      if (
        e.target.closest(
          ".m-cart-item__remove, .m-cart-remove-button, .m-cart-remove, [data-cart-remove], [data-remove]"
        )
      ) {
        scheduleSync("remove click");
      }

      if (e.target.closest(".m-quantity__button")) {
        scheduleSync("qty button");
      }
    });

    document.addEventListener("change", (e) => {
      if (e.target.matches(".m-quantity__input,input[name^='updates']")) {
        scheduleSync("qty change");
      }
    });

    setTimeout(() => scheduleSync("initial"), 800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initListeners);
  } else {
    initListeners();
  }
})();
